import { Component } from '@verndale/core';
import Pristine from 'pristinejs';
import Cookies from 'js-cookie';
import serialize from 'form-serialize';
import { getTimesConfig, buildOptionsHtml } from '../helpers/times';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $form: this.el,
      $error: this.el._$('.form-error'),
      $submit: this.el._$('[type="submit"]'),
      $success: this.el._$('.form-success'),
      $successCopy: this.el.parentNode._$('.contact-us__success'),
      $failedCopy: this.el.parentNode._$('.contact-us__failed'),
      $loadingRing: this.el._$('.loading-ring'),
      $topics: this.el._$$('.contact-us__topics select'),
      $date: this.el._$$('duet-date-picker'),
      $requiredWhenVisible: this.el
        ._$$('select')
        .filter(el => !!el.dataset.pristineRequiredMessageWhenVisible)
    };

    this.formEndPoint = this.dom.$form.dataset.endpoint;
    if (this.el.dataset.params) {
      this.queryParams = JSON.parse(this.el.dataset.params);
    }
    this.locationEndPoint = this.el.dataset.geoEndpoint;
    this.cookiesToSend = ['current_community'];
    this.actionForm = this.el.getAttribute('method');
    this.ajaxSubmit = this.dom.$form.classList.contains('form--ajax');
    this.loadingClass = 'form--loading';

    if (this.dom.$successCopy) {
      this.dom.$successCopy.hidden = true;
    }
    if (this.dom.$failedCopy) {
      this.dom.$failedCopy.hidden = true;
    }

    this.validateRequiredFields();
    this.verifyQueryParams();
  }

  addListeners() {
    this.dom.$form._on('submit', this.handleSubmit.bind(this));
    this.dom.$topics._on('change', () => {
      setTimeout(() => {
        this.validateRequiredFields();
      })
    });
  }

  moveDateInputName() {
    this.dom.$date.forEach(date => {
      const $dateInput = date._$('.duet-date__input');

      if (date.name && $dateInput) {
        $dateInput.name = date.name;
        date.removeAttribute('name');
      }
    });
  }

  validate() {
    this.moveDateInputName();

    this.pristineForm = new Pristine(this.dom.$form, {
      classTo: 'field',
      errorClass: 'field--error',
      successClass: 'field--success',
      errorTextParent: 'field',
      errorTextTag: 'small',
      errorTextClass: 'field__error'
    });
  }

  validateRequiredFields() {
    if (this.dom.$requiredWhenVisible.length) {
      this.dom.$requiredWhenVisible.forEach(el => {
        el.required = false

        const shouldValidateDatepicker = el.nodeName === 'DUET-DATE-PICKER' && el._$('.duet-date__input')?.offsetWidth > 0 && el._$('.duet-date__input')?.offsetHeight > 0;
        const shouldValidateOthers = el.nodeName !== 'DUET-DATE-PICKER' && el.offsetWidth > 0 && el.offsetHeight > 0;

        if (shouldValidateDatepicker || shouldValidateOthers) {
          if (el.nodeName === 'DUET-DATE-PICKER') {
            const error = el.dataset.pristineRequiredMessageWhenVisible;
            const $dateInput = el._$('.duet-date__input');
            $dateInput.dataset.pristineRequiredMessage = error;
            $dateInput.setAttribute('required', '');
          } else {
            el.setAttribute('data-pristine-required-message', el.dataset.pristineRequiredMessageWhenVisible)
            el.setAttribute('required', '')
          }
        }
      })
    }
    this.validate();
  }

  verifyQueryParams() {
    // If the query params are set, then we need to set them as cookies and send them as part of the form
    if (this.queryParams && this.queryParams.length > 0) {
      const urlParams = new URLSearchParams(window.location.search);

      this.queryParams.forEach(param => {
        if (urlParams.has(param)) {
          const cookie = { [param]: urlParams.get(param) };
          Cookies.set(param, JSON.stringify(cookie[param]));
          this.cookiesToSend.push(param);
        } else {
          const keys = Object.keys(Cookies.get());

          keys.forEach(key => {
            if (key.includes(param)) {
              this.cookiesToSend.push(param);
            }
          });
        }
      });
    }
  }

  setLoading(bool) {
    this.dom.$form.classList.toggle(this.loadingClass, bool);
    if (!this.dom.$submit) this.dom.$submit = this.el._$('[type="submit"]');

    if (this.dom.$loadingRing) {
      if (bool) {
        this.dom.$submit?.appendChild?.(this.dom.$loadingRing);
      } else {
        this.dom.$loadingRing.remove();
      }
    }
  }

  validateDateAndTime() {
    const seletedDate = this.dom.$date[0].value;
    const $dateInput = this.dom.$form.querySelector('.duet-date__input');
    const $timesSelect = this.dom.$form.querySelector('[name="preferredTime"]');
    const selectedTime = $timesSelect.value;

    const todayFormated = new Date().toLocaleString('sv', { timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit' }).split(' ')[0].split('/').reverse().join('-')
    const isToday = seletedDate === todayFormated;
    const today = new Date().toLocaleString('en-US', { timeZone: 'America/New_York' });

    const { parsedOptions, minDatePicker } = getTimesConfig(this.dom.$date[0], isToday, today);
    const optionsHtml = buildOptionsHtml(parsedOptions);

    if (seletedDate < minDatePicker) {
      const errorMessage = this.dom.$date[0].dataset.pristineNoTimes;
      $timesSelect.innerHTML = '';
      $timesSelect.pristine.errors = [];
      this.pristineForm.addError($timesSelect,  errorMessage);
      $timesSelect.innerHTML = optionsHtml;

      this.dom.$date[0].min = minDatePicker;
      $dateInput.pristine.errors = [];
      this.pristineForm.addError($dateInput, errorMessage);
      return false;
    }

    const validTime = parsedOptions.find(option => option.value === selectedTime);

    if (!validTime) {
      const errorMessage = $timesSelect.dataset.pristineNoLongerAvailable;
      $timesSelect.innerHTML = '';
      $timesSelect.pristine.errors = [];
      this.pristineForm.addError($timesSelect,  errorMessage);
      $timesSelect.innerHTML = optionsHtml;
      return false;
    }

    return true;
  }

  handleSubmit(e) {
    e.preventDefault();

    // Workaround for the pristine form validate method to work together with Sitecore personalize
    window.$ = () => {}

    const isValid = this.pristineForm.validate();

    if (!this.validateDateAndTime()) return;

    const headers = {
      'content-type': 'application/json'
    };
    if (!isValid) {
      e.preventDefault();
      return;
    }

    this.dom.$submit.disabled = true;
    this.setLoading(true);

    if (this.formEndPoint) {
      this.fetchResults(this.formEndPoint, headers);
    }
  }

  async fetchResults(url, headers) {
    const payload = {
      ...serialize(this.dom.$form, {
        hash: true,
        disabled: true,
        empty: true
      })
    };

    // BE needs cookies being sent with the request because of CDN caching
    this.cookiesToSend.forEach(cookie => {
      const cookieValue = Cookies.get(cookie);
      if (cookieValue) {
        try {
          let cookieValueParsed = JSON.parse(cookieValue);
          if (cookieValueParsed && cookie === 'current_community') {
            cookieValueParsed = cookieValueParsed.ssl_communityid;
          }
          // BE only needs ID, not the whole object (if needed uncomment community-context)
          // payload['community-context'] = JSON.parse(payload['community-context']);
          payload[cookie] = cookieValueParsed;
        } catch (e) {
          let cookieValueParsed = cookieValue;
          if (cookieValueParsed && cookie === 'current_community') {
            cookieValueParsed = cookieValueParsed.ssl_communityid;
          }
          // BE only needs ID, not the whole object (if needed uncomment community-context)
          // payload['community-context'] = JSON.parse(payload['community-context']);
          payload[cookie] = cookieValueParsed;
        }
      }
    });

    // BE needs the current geolocation and IP to be sent with the request.
    if (this.locationEndPoint) {
      const responseGeo = await fetch(this.locationEndPoint);
      const bodyGeoLocation = await responseGeo.json();

      payload.geolocation = { ...bodyGeoLocation };
    }

    const response = await fetch(url, {
      method: this.actionForm,
      body: JSON.stringify(payload),
      headers
    });

    if (!response.ok || response.status !== 200) {
      this.handleError(response.Message);
      return;
    }

    const body = await response.json();

    this.setLoading(false);
    this.handleSuccess(body, response.status);
  }

  handleSuccess(res, status) {
    if (this.dom.$error) this.dom.$error.hidden = true;

    if (res.redirectUrl || status === 200) {
      this.dom.$form.hidden = true;
      this.dom.$failedCopy.hidden = true;
      this.dom.$successCopy.hidden = false;

      return;
    }

    this.setLoading(false);
    this.dom.$form.classList.remove(this.errorClass);
    this.dom.$form.classList.add(this.successClass);
  }

  handleError(msg) {
    this.dom.$form.classList.add(this.errorClass);
    this.dom.$form.classList.remove(this.successClass);

    this.dom.$form.hidden = true;
    this.dom.$successCopy.hidden = true;
    this.dom.$failedCopy.hidden = false;

    if (this.dom.$error) {
      this.dom.$error.hidden = false;
      this.dom.$error.innerHTML = msg || this.defaultError;
    }

    this.setLoading(false);

    const event = new CustomEvent('submiterror', { detail: msg });
    this.dom.$form.dispatchEvent(event);
  }
}

export default Module;
